/* @jsx h */
import { defineComponent, h } from "vue";

type IconFieldProps = {
  icon: string;
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  autocomplete?: string;
  inputmode?: string;
  maxlength?: number;
  onInput: (value: string) => void;
};

export const IconField = defineComponent<IconFieldProps>({
  name: "AuthIconField",
  props: [
    "icon",
    "label",
    "type",
    "placeholder",
    "value",
    "autocomplete",
    "inputmode",
    "maxlength",
    "onInput",
  ],
  setup(props) {
    return () => (
      <label class="block">
        <span class="mb-1 block text-xs font-medium">
          {props.label}
        </span>
        <span class="relative block">
          <span
            class="material-symbols-outlined pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg"
            aria-hidden="true"
          >
            {props.icon}
          </span>
          <input
            type={props.type ?? "text"}
            placeholder={props.placeholder}
            class="input input-bordered w-full rounded-xl bg-base-100 pl-10 focus:input-primary"
            value={props.value}
            autocomplete={props.autocomplete}
            inputmode={props.inputmode as any}
            maxlength={props.maxlength}
            onInput={(event: Event) =>
              props.onInput((event.target as HTMLInputElement).value)
            }
          />
        </span>
      </label>
    );
  },
});
